import * as redux from 'redux'
import * as ReactRedux from 'react-redux'
import * as ReactFontAwesome from '@fortawesome/react-fontawesome'
import * as FontAwesomeSvgCore from '@fortawesome/fontawesome-svg-core'
import * as RCTree from 'rc-tree'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import EventEmitter from 'eventemitter3'

Object.defineProperties(uuidv4, { v4: { value: uuidv4 } })
if (!('default' in moment)) {
  Object.defineProperties(moment, { default: { value: moment } })
}
if (!('default' in EventEmitter)) {
  Object.defineProperties(EventEmitter, { default: { value: EventEmitter } })
}

export { default as axios } from 'axios'
export { default as classnames } from 'classnames'
export { uuidv4, moment, redux, EventEmitter, ReactRedux, RCTree, ReactFontAwesome, FontAwesomeSvgCore }
